import { environment } from '@env/environment';

export const INTERVAL = {
  MONTHLY: 'monthly',
  YEARLY: 'yearly'
} as const;

export const SUPPORTED_LANGUAGES = {
  DE_CH: 'de_CH',
  EN_US: 'en_US'
} as const;

export const CURRENCY = {
  CHF: 'CHF',
  EUR: 'EUR',
  USD: 'USD',
  GBP: 'GBP'
} as const;

export const RENDER_MODE = {
  DASHBOARD: 'dashboard',
  SALES: 'sales',
} as const;

export const SUBSCRIPTION = {
  BASIC: 'basic',
  STARTER: 'starter',
  TEAM: 'team',
  ENTERPRISE: 'enterprise',
} as const;

export const SUBSCRIPTION_IDS = {
  basic: 202,
  starter: 203,
  team: 204,
  enterprise: 205,
} as const;

export const APP_CONSTANTS = {
  DEFAULT_LANG: environment.defaultLocale,
  CALENSO_SUPPORT_EMAIL: environment.supportEmail
};

export const LANGUAGES = [{
  text: 'german',
  value: 'de',
  secondary_text: 'DE',
  locale: 'de_CH',
  flagIcon: '/assets/images/flags/german.png',
}, {
  text: 'english',
  value: 'en',
  secondary_text: 'EN',
  locale: 'en_US',
  flagIcon: '/assets/images/flags/english.png',
}];

export const PRICING_PLAN_PRECEDENCE = {
  202: 0, // BASIC
  203: 1, // STARTER
  204: 2, // TEAM
  205: 3, // ENTERPRISE
} as const;

// Retired legacy (v1) subscription-type IDs mapped to their v2 equivalent by
// tier precedence. Used ONLY to normalise a `minimum-subscription` floor whose
// stored value predates the v2 pricing migration, so the floor still applies.
// 106 (Enterprise Lite, no v2 tier) maps up to Enterprise.
// Intentionally NOT folded into PRICING_PLAN_PRECEDENCE: that map also feeds the
// current-plan upgrade/downgrade logic, which must keep returning `undefined`
// for a partner still on a legacy CURRENT subscription.
export const LEGACY_TO_V2_SUBSCRIPTION_ID: Record<number, number> = {
  103: 202, // Basic           -> Basic
  102: 203, // Professional    -> Starter
  104: 204, // Business        -> Team
  105: 205, // Enterprise      -> Enterprise
  106: 205, // Enterprise Lite -> Enterprise
};

export const CUSTOM_PLAN_USER_TYPE = 'additional_users';
export const CUSTOM_PLAN_STORE_TYPE = 'additional_stores';
export const CUSTOM_PLAN_GROUP_APPOINTMENT_TYPE = 'additional_events';
export const CUSTOM_PLAN_CONFERENCE_TYPE = 'additional_conferences';

export const DECIMAL_DIGITS = '1.2-2';
export const DECIMAL_LOCALE = 'en';
